import { createApiMutation } from "../../generated-factory";
import { apiClientManager } from "@app/stores/api-manager";
import type { UseToggleTemplateRequest, UseToggleTemplateData, UseUpdateItemRequest, UseUpdateItemData, UseUpdateTemplate2Request, UseUpdateTemplate2Data } from "@api/@types/activity-template";

export const useToggleTemplate = createApiMutation<UseToggleTemplateData, UseToggleTemplateRequest>({
  mutationFn: (req) => apiClientManager.apis.activityTemplate.toggleTemplate(req as UseToggleTemplateRequest),
});

export const useUpdateItem = createApiMutation<UseUpdateItemData, UseUpdateItemRequest>({
  mutationFn: (req) => apiClientManager.apis.activityTemplate.updateItem(req as UseUpdateItemRequest),
});

export const useUpdateTemplate2 = createApiMutation<UseUpdateTemplate2Data, UseUpdateTemplate2Request>({
  mutationFn: (req) => apiClientManager.apis.activityTemplate.updateTemplate2(req as UseUpdateTemplate2Request),
});

export type { UseToggleTemplateRequest, UseToggleTemplateData, UseUpdateItemRequest, UseUpdateItemData, UseUpdateTemplate2Request, UseUpdateTemplate2Data } from "@api/@types/activity-template";
